function text(value) {
    return typeof value === "string" ? value.trim() : "";
}

function customMessage(merchant, language) {
    if (language === "es") return text(merchant.outOfStockMessageEs);
    if (language === "fr") return text(merchant.outOfStockMessageFr);
    return text(merchant.outOfStockMessage);
}

function globalMessage(message, language) {
    if (!message) return "";
    if (language === "es") return text(message.es);
    if (language === "fr") return text(message.fr);
    return text(message.en);
}

export function outOfStockInfoMessage(merchant, globalOutOfStockMessage, language) {
    if (!merchant || !merchant.outofstock) return "";
    const selected = String(language || "en").toLowerCase().split("-")[0];
    return customMessage(merchant, selected) || globalMessage(globalOutOfStockMessage, selected);
}
